// extracted by mini-css-extract-plugin
export var container = "Orders-module--container--ebO1I";
export var content = "Orders-module--content--RkZp1";
export var noOrders = "Orders-module--noOrders--Shn7d";
export var subHeader = "Orders-module--subHeader--CxTVO";